import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { SvgArrowPointRight } from "@ugitgud/legos/ui/icon/SVG/ArrowPointRight";

interface PlayerLandingModuleProps {
  userName: string;
  tagLine: string;
  iconId?: number;
  onScrollToModules: () => void;
}

export const PlayerLandingModule: React.FC<PlayerLandingModuleProps> = ({ userName, tagLine, iconId, onScrollToModules }) => {
  const { getProfileIconImg } = getRiotAssetsContext();

  return (
    <section className="flex flex-col space-y-[100px] items-center">
      <div className="flex flex-col items-center space-y-0">
        <img className="w-[85px] h-[85px] rounded-[50px] border-[2px] border-[#F4C874]" src={getProfileIconImg(iconId)} />
        <h1 className="text-center text-[96px] font-medium uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent">
          {userName}
        </h1>
        <p className="text-white text-center text-[32px] font-normal uppercase leading-normaldrop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow]">
          #{tagLine}
        </p>
      </div>
      <div className="flex flex-col space-y-[60px] items-center">
        <div className="flex space-x-[24px] justify-center">
          <Icon icon={<SvgYearInReviewLogoFull />} className="w-[156.41px] h-[150px]" />
          <div className="flex flex-col space-y-[25.54px]">
            <Icon icon={<SvgYearInReviewTextFull />} className="w-[235.168px] h-[114.397px] " />
            <div className="w-[232.4px] h-[5.025px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)]  border-0" />
          </div>
        </div>
        <Icon icon={<UGGLogoFull />} className="w-[111px] h-[36px] shrink-0 aspect-[37/12]" />
      </div>
      <Icon
        icon={<SvgArrowPointRight />}
        className="w-[36px] h-[36px] rotate-90 shrink-0 aspect-square cursor-pointer"
        onClick={onScrollToModules}
      />
    </section>
  );
};
